import React, { useEffect } from 'react'
import Layout from 'components/LayoutForPortal'
import DailyUpdateList from 'components/Table/BasicTable'
import IntlMessages from "util/IntlMessages"
import { DataGetAction } from 'redux/actions/http'
import { useDispatch, useSelector } from 'react-redux'
import { DatePicker, Input } from 'antd'
import Title from 'components/Title'
import { intlPlaceholder } from "util/intlPlaceholder"
import DailyUpdateModal from 'components/Modal/DailyActivity'
import moment from 'moment'

const { RangePicker } = DatePicker;
const Index = () => {

    const dispatch = useDispatch()
    const dailyUpdateProps = useSelector(state => state.dailyUpdate)
    const { dailyUpdateList, saveDailyUpdate,gettingDailyUpdateSpinner } = dailyUpdateProps

    console.log("========= dailyUpdateList =======", dailyUpdateList);
    const fetchDailyUpdateList = () => {

        dispatch(DataGetAction('getDailyUpdate', { query: 'all' }, 'gettingDailyUpdate'));
        dispatch(DataGetAction('getPatientInfo', '', 'gettingPatientInfo'))
    }
    useEffect(fetchDailyUpdateList, [])

    if (saveDailyUpdate) {
        fetchDailyUpdateList()
        
        dispatch({
            type: 'resetDailyUpdate'
        })
    }

    const columns = [
        {
            title: <IntlMessages id="dailyUpdate.id" />,
            render: record => <span>{record.dailyUpdateId}</span>,
            key: "userId"
        },
        {
            title: <IntlMessages id="dailyUpdate.filledBy" />,
            render: record => <span>{record.filledBy}</span>,
            key: "filledBy"
        },
        {
            title: <IntlMessages id="dailyUpdate.dateTime" />,
            render: record => <span>{moment(record.createdAt).format('DD MMM, YYYY h:mm a')}</span>,
            key: "dateTime"
        },

        {
            title: '',
            render: (record) => <span className="gx-link" onClick={() => { openDailyUpdateModal(record) }}><IntlMessages id="dailyUpdate.view" /></span>,
            key: "view"
        },
    ]

    const onChange = (dates, dateStrings) => {
        if (dates && dates.length) {
            dispatch(DataGetAction('getDailyUpdate', { query: "search", key: "date", stateDate: dates[0], endDate: dates[1] }, 'gettingDailyUpdate'));
        }
    }

    const openDailyUpdateModal = (record) => {
        dispatch({
            type: 'show_daily_activity_update_modal',
            payload: record,
            disabled: true,
            showInitialValue: true
        })
    }

    return (
        <Layout>
            <div className="gx-d-flex gx-flex-row gx-justify-content-between">
                <div className="gx-mb-2 gx-mb-md-0">
                    <Title title={<IntlMessages id="dailyUpdate.pageTitle" />} />
                </div>
                <div className="gx-d-flex gx-flex row">
                    <div className=" gx-mb-3 gx-mb-md-0">
                        <RangePicker onChange={onChange} />
                    </div>
                    <div className="gx-my-0  gx-ml-2" style={{ width: '240px' }}>
                        <Input.Search
                            showSearch
                            placeholder={intlPlaceholder('dailyUpdate.filter.nameorId')}
                            filterOption={false}
                            onChange={(e) => dispatch(DataGetAction('getDailyUpdate', { name: e.target.value }, ''))}
                        />
                    </div>


                </div>

            </div>
            <DailyUpdateList loading={gettingDailyUpdateSpinner} data={gettingDailyUpdateSpinner ? [] : dailyUpdateList} columns={columns} />
            <DailyUpdateModal />

        </Layout>
    )
}

export default Index
